import React from "react";
import "./App.css";
import theme from "./themes/LightTheme";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Login from "./pages/login/Login";
import Home from "./pages/home/Home";
import PlanInfo from "./pages/planInfo/PlanInfo";
import UserProvider from "./providers/userProvider";
import Admin from "./pages/admin/admin";
import Offers from "./pages/admin/offers/offers";
import { ThemeProvider } from "@mui/material";
import Squares from "./pages/admin/squares/squares";
import Catalogs from "./pages/admin/catalogs/catalogs";
import Banners from "./pages/admin/banners/banners";
import Folders from "./pages/folders/folders";
import Statistics from "./pages/admin/statistics/statistics";
import Notifications from "./pages/admin/notifications/notifications";
import Carrusel from "./pages/admin/carrusel/carrusel";
import SupportMaterialAdmin from "./pages/admin/supportMaterial/SupportMaterialAdmin";
import SupportMaterialDoc from "./components/SupportMaterial/SupportMaterialAdmin";
import CmsAdmin from "./pages/admin/cms/cms";
import CmsDemo from "./pages/admin/cms/demo";
import ReordenView from "./pages/admin/cms/reorden/ReordenView";
import AdminUser from "./pages/adminUser/adminUser";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <UserProvider>
          {/* <Chat/> */}
          <Routes>
            <Route path="/index.html" element={<Navigate to="/login" />} />
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path="/PlanInfo" element={<PlanInfo />} />
            <Route path="/administrator" element={<Admin />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/squares" element={<Squares />} />
            <Route path="/catalogs" element={<Catalogs />} />
            <Route path="/banners" element={<Banners />} />
            <Route path="/carrusel" element={<Carrusel />} />
            <Route path="/manuales" element={<Folders />} />
            <Route path="/statistics" element={<Statistics />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/material" element={<SupportMaterialDoc />} />
            <Route path="/admin-cms" element={<CmsAdmin />} />
            <Route path="/cms-demo" element={<CmsDemo />} />
            <Route path="/admin-cms-reorden" element={<ReordenView />} />
            <Route path="/admin-user" element={<AdminUser />} />
            {/* <Route path="/metas" element={<Metas />} /> */}
          </Routes>
        </UserProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
